import React from 'react';
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {Image} from "../../../../core/components/image/image";
import {
  SportTypeStatisticTypesImageRequestParams
} from "../../models/assets/sport-type.statistic-types.image-request-params";
import styles from "../../styles/competitor-players-stats-module.module.scss";
import classNames from "classnames";
import {
  LineupsMemberStatsViewModel
} from "../../../../domain/yard/lineups/lineups-member/stats/lineups-member.stats.view-model";

export class CompetitorPlayersStatsModulePlayerStatsTopStatsContentCardProps extends BaseProps {
  topStatsIconSize: Number;
  isSmallView: Boolean;
  stat: LineupsMemberStatsViewModel
}

export const CompetitorPlayersStatsModulePlayerStatsTopStatsContentCard = ({
                                                                             stat,
                                                                             topStatsIconSize
                                                                           }: CompetitorPlayersStatsModulePlayerStatsTopStatsContentCardProps) => {
  const iconProps = {
    src: new SportTypeStatisticTypesImageRequestParams(stat.imageId, topStatsIconSize, undefined, stat.color),
    style: {
      width: topStatsIconSize
    },
    eager: true
  }

  return (
    <div className={classNames(styles.player_stats_top_stats_content_card_container)}>
      <div className={classNames(styles.player_stats_top_stats_content_card_logo)}>
        <Image {...iconProps}/>
      </div>
      <div className={classNames(styles.player_stats_top_stats_content_card_value)}>{stat.value}</div>
      <div
        className={classNames(styles.player_stats_top_stats_content_card_stats_name)}>{stat.shortName}</div>
    </div>
  )
}
